import { useEffect, useRef, useState } from 'react';
import { hasWebGL } from './useIsMobile';
import { logWarn } from '../lib/log';
import { COLORS } from '../constants';
import { JAR_TYPES } from '../components/three/jarMeta';

const memo = new Map();
let modPromise = null;
const loadModule = () => modPromise || (modPromise = import('../components/three/jarSnapshots'));
const keyOf = (it) => `${it.line_color}|${it.product_type}|${it.main_ingredient || ''}`;
const toJob = (it) => ({
  color: COLORS[it.line_color] || '#ffffff',
  type: it.product_type,
  label: [JAR_TYPES[it.product_type]?.label[0] || '', (it.main_ingredient || '').toUpperCase()],
});

export const useKitJarImages = (items) => {
  const sig = items.map(keyOf).join(',');
  const [urls, setUrls] = useState(() => items.map((it) => memo.get(keyOf(it)) || null));
  const itemsRef = useRef(items);
  itemsRef.current = items;

  useEffect(() => {
    const items = itemsRef.current;
    if (items.every((it) => memo.has(keyOf(it)))) { setUrls(items.map((it) => memo.get(keyOf(it)))); return undefined; }
    if (!hasWebGL()) return undefined;
    let alive = true;
    loadModule()
      .then((m) => m.renderJarImages(items.map(toJob)))
      .then((canvases) => {
        const next = canvases.map((c, i) => {
          const u = c.toDataURL('image/png');
          memo.set(keyOf(items[i]), u);
          return u;
        });
        if (alive) setUrls(next);
      })
      .catch((error) => logWarn('3D jar render failed, using fallback:', error));
    return () => { alive = false; };
  }, [sig]);

  return urls;
};

export default useKitJarImages;
